<script setup lang="ts">
import { CopyOutlined } from '@ant-design/icons-vue';
import { useClipboard } from '@vueuse/core';
import { message } from 'ant-design-vue';
import { useSessionStore } from '@/store/modules/session';

const sessionStore = useSessionStore();
const props = defineProps<{
    orderId: string;
    price: string;
    title: string;
    cover: string;
    competitionType: number;
    num: number | string;
}>();

const { copy } = useClipboard();

const handleCopy = () => {
    copy(props.orderId);
    message.success('复制成功');
};

const handleClick = () => {
    sessionStore.MessageTabChange({
        type: 'Order',
        orderId: props.orderId
    });
};
</script>

<template>
    <div
        class="w-84"
        @click="handleClick"
    >
        <div class="flex gap-2">
            <div class="truncate">订单编号：{{ props.orderId }}</div>
            <CopyOutlined
                class="cursor-pointer color-primary"
                @click="handleCopy"
            />
            <div
                v-if="props.competitionType"
                class="color-#8c5af0 border-solid border-#8c5af0 border-1px rounded-4px pt-2px text-center pb-2px w-40px text-10px mt-2px"
            >
                三创赛
            </div>
        </div>
        <div class="flex-y-center gap-4 mt-2">
            <img
                class="w-76px h-76px flex flex-shrink-0"
                :src="props.cover"
                alt=""
            />
            <div class="flex-col gap-4 w-full">
                <div class="line-clamp-2">
                    {{ props.title }}
                </div>
                <div class="flex-bc">
                    <div>
                        <span>¥</span>
                        <span>{{ props.price }}</span>
                    </div>
                    <div class="text-gray">共{{ props.num }}件</div>
                </div>
            </div>
        </div>
    </div>
</template>
